module.exports = __webpack_public_path__ + "static/img/erweima.7812b8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/erweima.jpg
// module id = fLB0
// module chunks = 1